import { useEffect, useState } from 'react';
import { useProductApiV1 } from '../../../../clients/quipli-service/product/product-api-v1';
import { Button } from '../../../../components/form/button';
import { Typography } from '../../../../components/typography/typography';
import { Field } from '../../../../components/field/field';
import { Tooltip } from '../../../../components/tooltip/tooltip';
import Icon from '../../../../components/icons/icon';
import { CKEditor } from '@ckeditor/ckeditor5-react';
import './product-description-form.scss';
import QuipliEditor from 'ckeditor';

export const ProductDescriptionForm = ({
  productName,
  currentDescription,
}: {
  productName: string;
  currentDescription: string;
}) => {
  const [editorFailed, setEditorFailed] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [descriptionInput, setDescriptionInput] = useState<string>(productName);
  const [description, setDescription] = useState<string>(currentDescription);
  const { generateAiDescription } = useProductApiV1();
  const generateDescription = async () => {
    setIsLoading(true);
    const d = await generateAiDescription(descriptionInput);
    setDescription(`${description}${description ? '<br/>' : ''}${d}`);
    setIsLoading(false);
  };

  useEffect(() => {
    $('input#prod_long_desc').val(description);
  }, [description]);

  useEffect(() => {
    if (editorFailed) {
      setEditorFailed(false);
    }
  }, [editorFailed]);

  return (
    <>
      {!editorFailed && (
        <div className="">
          <CKEditor
            editor={QuipliEditor as any}
            data={description}
            onChange={(event, editor) => setDescription(editor.getData())}
            onError={(e, p) => {
              if (!p.willEditorRestart) {
                setTimeout(() => setEditorFailed(true), 100);
              }
            }}
          />

          <div className="mt-2">
            <Typography type="text-md" weight="bold">
              Feeling stuck coming up with a description? Let AI write it!
            </Typography>
            <div className="flex mt-4 gap-8 items-center">
              <div className="flex gap-4">
                <div className="flex gap-1 items-center">
                  <Typography type="text-xs" weight="medium">
                    Name, make, model, etc.
                  </Typography>
                  <Tooltip tooltip="Include as much detail as possible to generate an accurate description">
                    <Icon icon="InfoCircle" />
                  </Tooltip>
                </div>
                <Field
                  className="w-full"
                  type="text"
                  value={descriptionInput}
                  onChange={(v) => setDescriptionInput(v)}
                />
              </div>
              <Button
                disabled={!descriptionInput || isLoading}
                onClick={generateDescription}
                className="h-[40px] button-primary"
              >
                Generate Description with AI
              </Button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
